import * as Sentry from "@sentry/react";

import { config } from "~/config";

export const initSentry = () => {
  Sentry.init({
    enabled: config.environment !== "local",
    environment: config.environment,
    dsn: config.sentryDSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.feedbackIntegration({
        autoInject: false,
        showBranding: false,
      }),
    ],
    // Traces
    tracesSampleRate: 1.0,
    tracePropagationTargets: [config.graphqlEndpoint, config.cnutGraphqlEndpoint, config.appsync.graphqlEndpoint],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};
